export default __webpack_public_path__ + "static/media/menu_card_assessment.1ef58be8.svg";